<div class="alert alert-danger" *ngIf="errorMessage">{{errorMessage}}</div>
<app-home-dashboard [loading]="loading" dashboardLabel="Examiner dashboard"
    [displayName]="examinerFirstName" [checkrides]="homeCheckrides"
    [tasks]="tasks" dashboardGroupKey="examiner-home-kpis" [kpiScopeFilters]="kpiScopeFilters">
</app-home-dashboard>
